import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'svg-icon',
  styleUrls: ['./svg-icon.component.scss'],
  template: `
    <svg
      [attr.width]="width"
      [attr.height]="height"
      [style.max-width]="maxWidth"
      [style.filter]="'var(--pencil-svg-icon-filter, ' + filter + ')'"
    >
      <use attr.xlink:href="assets/icons/svg-sprite/{{ svgSpriteName }}#{{ icon }}"></use>
      <use attr.xlink:href="#{{ icon }}"></use>
    </svg>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SvgIconComponent {
  public svgSpriteName = environment.svgSpriteName;
  @Input() icon?: string;
  @Input() width?: string;
  @Input() height?: string;
  @Input() maxWidth?: string = '100%';
  @Input() filter?: string = '';
}
